import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea,Message,Popup,Grid,Header } from 'semantic-ui-react'

import {WindowReload, WindowURL, WindowLocation,CompanyName} from '../../config/settings'
import Alertmessage from '../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {validateStep1} from './validate'


export default function OpenAccountStep1(props) {

  function CallbackFunction(data){
		props.active(data);
	}
  function CallbackState(data){
    props.callstate(data);
  }

	/*-------------------------------------------------------------------------
	 Forms: Adding
	--------------------------------------------------------------------------*/
	const [state,setstate] = useState({
		reps_id:props.state.reps_id,
		first_name:props.state.first_name,
		last_name:props.state.last_name,
		middle_name:props.state.middle_name,
		primary_number:props.state.primary_number,
		country:props.state.country,
		email:props.state.email,
	});


	function handleSubmitForm(values, props){

    CallbackState({
      reps_id:values.reps_id,
  		first_name:values.first_name,
  		last_name:values.last_name,
  		middle_name:values.middle_name,
  		primary_number:values.primary_number,
  		country:values.country,
  		email:values.email,
    });
    CallbackFunction(2);
	}


	/*-------------------------------------
	 	Queries
	--------------------------------------*/
	const [repslist, setrepslist] = useState([]);
	const [countries, setcountries] = useState([]);
	const [seclist, setseclist] = useState([]);

	function ApplicationQuries(){
		let formData = new FormData();
		formData.append('type','query_application');
		axios.post('/application/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				setrepslist(obj.reps);
				setcountries(obj.countries);
				setseclist(obj.seclist);
		})
		.catch(function (error){
		});
	}


	/*-------------------------------------
		Content
	--------------------------------------*/
	const [content, setcontent] = useState({
			form: {
				step1: {
					title:'',
					content:'',
					message:'',
				},
				country: {
					title:'',
					content:'',
				}
			},
	});
	function ContentApplication(){
		let formData = new FormData();
		formData.append('type','content');
		axios.post('/content/request.php',formData)
		.then(function (response) {
				let obj = response.data;
				setcontent({
					...content,
					form: {
						step1: {
							title:obj.form.step1.title,
							content:obj.form.step1.content,
							message:obj.form.step1.message,
						},
						country: {
							title:obj.form.country.title,
							content:obj.form.country.content,
						}
					},
				});
		})
		.catch(function (error){
		});
	}

	useEffect(()=>{
		ContentApplication();
		ApplicationQuries();
	},[]);


	return (
		<React.Fragment>
				<Form>
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={validateStep1}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps
						return(
			         <div className="open-account-panel">
                 <div className="open-account-panel-header">
                 
                   {/*<h2>{content.form.step1.title}</h2>
                   {content.form.step1.content!=''?renderHTML(content.form.step1.content):''}
									 <Message visible negative>{content.form.step1.message}</Message>*/}
									 <h2>{content.form.step1.title}</h2>
									 <Message visible negative>{content.form.step1.message}</Message>
                </div>
			            <div className="open-account-panel-body">

									<div className="wrapperinline">

										<div className="formwrapp-inline alignright">
											<div><label className="req">Representative</label></div>
											<div>
												<Form.Group widths="equal">
													<Field name="reps_id">
														{({ field, form }) => (
																<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<Select selectOnBlur={false}
																			{...field}
																			options={repslist}
																			onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
														)}
													</Field>
												</Form.Group>
											</div>
									  </div>

										<div className="formwrapp-inline alignright">
											<div><label className="req">First Name</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="first_name">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
										</div>

										<div className="formwrapp-inline alignright">
											<div><label>Middle Name</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="middle_name">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
										</div>
										<div className="formwrapp-inline alignright">
											<div><label className="req">Last Name</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="last_name">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
										</div>
										<div className="formwrapp-inline alignright">
											<div>
													<label className="req">Country
															<Popup trigger={<span className="infofields">(What's this?)</span>} position='top left'>
														    <Grid centered divided columns={1}>
														      <Grid.Column>
														        <Header as='h4'>{content.form.country.title}</Header>
														        <p>{content.form.country.content}</p>
														      </Grid.Column>
														    </Grid>
														  </Popup>
													</label>
											</div>
											<div>
													<Form.Group widths="equal">
														<Field name="country">
															{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<Select selectOnBlur={false}
																				{...field}
																				options={countries}
																				onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
															)}
														</Field>
													</Form.Group>
											</div>
										</div>

										<div className="formwrapp-inline alignright">
											<div><label className="req">Primary/Daytime Phone</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="primary_number">
														{({ field, form }) => (
														<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
										</div>

										<div className="formwrapp-inline alignright">
											<div><label className="req">Email</label></div>
											<div>
												<Form.Group widths="equal">
													<Field name="email">
															{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<Input {...field} onChange={handleChange}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
											</div>
										</div>

									</div>{/*.wrapperinline*/}
									</div>{/*.panel-body*/}
			            <div className="open-account-panel-footer textright">
									    <div className="wrapperinline">
                      	<Button content='Continue' className="primary" icon='right arrow' labelPosition='right' onClick={handleSubmit}/>
											</div>
									</div>
			         </div>

						 )}}/>
					</Form>
    </React.Fragment>
  )
}
